module.exports = __webpack_public_path__ + "static/media/au.cf30ad1f.svg";